import type { CalidadControlModificacion } from "../../../types/control-modificaciones";

export type CategoriaItv = "M1" | "N1";
export type EstadoIntervencionProgramada = "proxima" | "futura";
export type TipoIntervencionProgramada = "itv" | "mantenimiento_anual" | "otra";

export type MantenimientoVehiculoIntervencion = {
  id: number;
  vehiculo_id: number;
  fecha: string | null;
  intervencion: string;
  usuario_modificacion_id: number | null;
};

export type MantenimientoVehiculoIntervencionProgramada = {
  id: string;
  vehiculo_id: number;
  matricula: string | null;
  marca_modelo: string | null;
  tipo: TipoIntervencionProgramada;
  titulo: string;
  fecha: string;
  estado: EstadoIntervencionProgramada;
  dias_restantes: number;
  origen: "registrada" | "matriculacion" | "historial" | "referencia";
  registrada: boolean;
  registro_id: number | null;
};

export type MantenimientoVehiculo = {
  id: number;
  matricula: string | null;
  marca_modelo: string | null;
  responsable: string | null;
  regimen: string | null;
  tipo_combustible: string | null;
  seguro: string | null;
  fecha_matriculacion: string | null;
  categoria_itv: CategoriaItv | null;
  fecha_itv: string | null;
  fecha_mantenimiento_anual: string | null;
  intervenciones: MantenimientoVehiculoIntervencion[];
  proximas_intervenciones: MantenimientoVehiculoIntervencionProgramada[];
  usuario_modificacion_id: number | null;
};

export type MantenimientoVehiculoPayload = Omit<
  MantenimientoVehiculo,
  "id" | "intervenciones" | "proximas_intervenciones" | "usuario_modificacion_id"
>;

export type IntervencionPayload = {
  fecha: string | null;
  intervencion: string;
};

export type MantenimientoVehiculosResponse = {
  data: {
    vehiculos: MantenimientoVehiculo[];
    proximas_intervenciones: MantenimientoVehiculoIntervencionProgramada[];
    control_modificaciones: CalidadControlModificacion[];
  };
  filter_options: {
    responsables: string[];
    combustibles: string[];
    anios: number[];
  };
  meta: {
    total_vehiculos: number;
    total_intervenciones: number;
    total_intervenciones_pendientes: number;
    intervenciones_proximas: number;
  };
};

export const emptyVehicle: MantenimientoVehiculoPayload = {
  matricula: "",
  marca_modelo: "",
  responsable: "",
  regimen: "",
  tipo_combustible: "",
  seguro: "",
  fecha_matriculacion: null,
  categoria_itv: "M1",
  fecha_itv: null,
  fecha_mantenimiento_anual: null,
};

export const emptyIntervention: IntervencionPayload = {
  fecha: null,
  intervencion: "",
};

export const categoriaItvLabels: Record<CategoriaItv, string> = {
  M1: "M1 · Turismo / hasta 8 plazas",
  N1: "N1 · Mercancías hasta 3,5 t",
};
